import { render, staticRenderFns } from "./ArticleAnimationAudio2.vue?vue&type=template&id=a5827d08&scoped=true"
import script from "./ArticleAnimationAudio2.vue?vue&type=script&lang=js"
export * from "./ArticleAnimationAudio2.vue?vue&type=script&lang=js"
import style0 from "./ArticleAnimationAudio2.vue?vue&type=style&index=0&id=a5827d08&prod&lang=less&scoped=true"
import style1 from "./ArticleAnimationAudio2.vue?vue&type=style&index=1&id=a5827d08&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5827d08",
  null
  
)

export default component.exports